import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class PickRequestPayload extends RequestPayload {
    public pick: string | number;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/requests/pick-request.ts